import { useState, FC, MouseEvent } from 'react'
import {
  BulkSelectContainer,
  BulkSelectCheckbox,
  BulkSelectCheckboxLabel,
  BulkSelectOptionsList,
  BulkSelectOptionItem
} from './styles'
import { HiOutlineChevronDown, HiOutlineCheck } from 'react-icons/hi'
import { ApplicationTypeFilterOptions, AppStatusFilterOptions } from 'src/dtos/portal'

interface BulkSelectProps {
  selection: ApplicationTypeFilterOptions | undefined;
  onSelect: (option: ApplicationTypeFilterOptions | undefined) => void;
  applicationStatus: AppStatusFilterOptions;
}

const BulkSelect: FC<BulkSelectProps> = ({ selection, onSelect, applicationStatus }) => {
  const [isListOpen, setIsListOpen] = useState(false)

  const handleCheckboxClick = (event: MouseEvent<HTMLDivElement>) => {
    if(!!selection) {
      event.stopPropagation()
      onSelect(undefined)
    }
  }

  return (
    <BulkSelectContainer onClick={() => {
        if(applicationStatus === 'IN_PROGRESS')
          setIsListOpen(prev => !prev)
        else {
          if(selection)
            onSelect(undefined)
          else
            onSelect('ALL')
        }
      }}
    >
      <BulkSelectCheckbox
        isChecked={selection !== undefined}
        onClick={event => handleCheckboxClick(event)}
      >
        <HiOutlineCheck color='#fff'/>
      </BulkSelectCheckbox>
      <BulkSelectCheckboxLabel>Select {applicationStatus === 'IN_PROGRESS' ? <HiOutlineChevronDown /> : 'All'}</BulkSelectCheckboxLabel>
      {applicationStatus === 'IN_PROGRESS' ? (
        <BulkSelectOptionsList isOpen={isListOpen}>
          <BulkSelectOptionItem onClick={() => onSelect('ALL')}>All</BulkSelectOptionItem>
          <BulkSelectOptionItem onClick={() => onSelect('LAWYER')}>Lawyer</BulkSelectOptionItem>
          <BulkSelectOptionItem onClick={() => onSelect('JUDGE')}>Judge</BulkSelectOptionItem>
        </BulkSelectOptionsList>
      ) : null}
    </BulkSelectContainer>
  )
}

export default BulkSelect